<template>
    <div>
        <el-form ref="form" :rules="rules" :model="form" size="small" label-width="80px">
            <h4 class="textStyle">视频仅支持MP4格式，音频仅支持MP3格式</h4>
            <el-form-item label="选择目录" prop="dir">
                <el-cascader v-model="form.dir" @change="selectDir" :options="treeAll"
                             :props="{ value: 'id', label: 'name', children: 'childList', checkStrictly: true, expandTrigger: 'hover'}">
                </el-cascader>
            </el-form-item>
            <el-form-item label="选择文件" prop="selectFile">
                <input ref="files" multiple type="file" @change="getFileList" name="" style="display: none"
                       id="upFile"/>
                <label for="upFile" class="el-button el-button--primary el-button--small">
                    选择文件
                </label>
            </el-form-item>
            <div class="dividing"></div>
            <el-alert @close="() => removeList(i)" v-for="(item, i) in currentUpList" :key="i" type="info">
                <div slot="title">
                    <i class="el-icon-collection-tag"></i>
                    {{ item.name }}
                </div>
            </el-alert>
        </el-form>
    </div>
</template>
<script>
import { getTreeAll } from '@/api/fileManges.js'

export default {
  data () {
    return {
      form: {
        dir: [],
        selectFile: ''
      },
      currentUpList: [],
      treeAll: [],
      rules: {
        dir: [{
          required: true,
          message: '请选择目录',
          trigger: 'change'
        }],
        selectFile: [
          {
            required: true,
            message: '请选择文件',
            trigger: 'change'
          }
        ]
      }
    }
  },
  props: {
    uploading: Boolean
  },
  created () {
    getTreeAll({}).then((res) => {//获取所有课程的树形结构
      this.treeAll = this.formateTree([res] || [])
    })
  },
  methods: {
    close () {
      this.$emit('showdir')
    },
    formateTree (list) {
      // 只是为了把叶子节点childlist清除好让element那个二傻子用
      list.map((v, i) => {
        if (v.childList) {
          if (v.childList.length) {
            v.childList = this.formateTree(v.childList)
          } else {
            delete v.childList
          }
        }
        return v
      })
      return list
    },
    //文件上传change事件
    getFileList () {
      
      //文件的信息
      const files = Array.from(this.$refs.files.files).map((v, i) => {
        return {
          name: v.name,
          percentage: 0,
          raw: v,
          size: v.size
        }
      })
     
      if (files.length) this.form.selectFile = 1
      this.$refs.files.value = ''
      this.arr = files
      files.forEach((file) => {
        this.currentUpList.push(file)
        this.$emit('pushListFun', file)
      })
    },
    removeList (index) {
      console.log('step1', index)
      this.$emit('removeList', index)
    },
    //目录选择事件
    selectDir (val) {
      const selectType = val || []
      if (!selectType.length) return
      this.$emit('setDirId', selectType[selectType.length - 1])
    }
  }
}
</script>
<style scoped>
    .dividing {
        border-bottom: 1px dashed #eee;
        margin: 1em 0;
    }

    .textStyle {
        color: red;
        margin-bottom: 0.5em;
        margin-left: 0.7em;
    }
</style>
